export default __webpack_public_path__ + "static/media/virginia-salomon-1.ff8a8163.webp";